import { useCallback, useEffect, useState } from "react";
import {
  fetchModelCurrencyOverview,
  type ModelCurrencyOverview,
} from "@/services/adminModelCurrency";
import { describeApiError } from "./helpers";

/** Loads the overview and exposes a quiet refresh (no spinner flash after actions). */
export function useModelCurrencyOverview() {
  const [overview, setOverview] = useState<ModelCurrencyOverview | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(async () => {
    try {
      const data = await fetchModelCurrencyOverview();
      setOverview(data);
      setError(null);
    } catch (err) {
      setError(describeApiError(err));
    } finally {
      setLoading(false);
    }
  }, []);

  /** Retry after a failed load: show the spinner again, then fetch. */
  const retry = useCallback(() => {
    setLoading(true);
    return refresh();
  }, [refresh]);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return { overview, loading, error, refresh, retry };
}
